export class SupportingDocumentDetails{
    podReceivedDate: string;
    statusName: string;
    engagementType: string;
    engagementName: string;
    dateSent:any;
    supportingDocumentId:string;
    adjudicationStatusName:any;
    description:any
}